import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../components/CustomInput";
import { Outlet } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../layout/AuthLayout/Footer";

export default function GuidePage() {
  const [guidState, setGuideState] = useState();
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title="راهنما بازارگاه" hasScroll={hasScroll} />

      <Box
        ref={divRef}
        sx={{
          maxWidth: "600px",
          width: {
            xs: "100%",
          },
          // border: "1px solid gray",
          marginX: "auto",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          paddingY: "20px",
          gap: "12px",
        }}
      >
        <Outlet />
        <AuthFooter />
      </Box>
    </>
  );
}
